export const HTTP_CODE = {
  ACCEPTED: 202,
  BADREQUEST: 400,
  PERMISSION_DENIED:424,
  CONFLICT: 409,
  CREATED: 201,
  OK: 200,
  SERVER_ERROR:500
};
